import { ProspectInterface } from '../interfaces';
import { createTableColumns } from '../utils';

import Axios from "../libraries/axios";

class ProspectModel implements ProspectInterface {
  [key: string]: any
  _id = '';
  firstName = '';
  lastName = '';
  email = '';
  source = '';
  phone = '';
  product = '';
  createdAt = new Date();
  updatedAt = new Date();

  constructor(props: ProspectInterface) {
    if (props) {
      Object.assign(this, props);
    }
  }

  static getColumns() {
    return createTableColumns(['firstName', 'lastName', 'email', 'product', 'stepsSeen', 'createdAt']);
  }

  static async fetchAll<ReturnType>(
    params: any = {},
    config: any = {}
  ): Promise<ReturnType> {
    try {
      const { data } = await Axios.get('/api/prospects', {
        params,
        ...config,
      });

      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }
}

export default ProspectModel;
